module.exports = __webpack_public_path__ + "img/td_ad_04.e169d4dc.jpg";